























































































































































































import { Component, Mixins, Inject, Prop } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";

@Component({
  components: {
    "custom-fields-view": () =>
      import("@/components/app/global/customFields/customFieldsView.vue"),
    "invoice-items": () =>
      import("@/components/app/global/invoices/invoiceItems.vue"),
    "invoice-details-skeleton": () =>
      import("@/components/app/global/invoices/invoiceDetailsSkeleton.vue")
  }
})
export default class InvoiceDetails extends Mixins(RequestPromises, Context) {
  // Inject
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;
  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;
  // Props
  @Prop({ default: true })
  public canDownload!: boolean;
  // Computed
  public get $invoiceData() {
    return this.$invoiceProvider();
  }
  public get clientCompany() {
    return this.$_.get(
      this.$invoiceData.invoiceDataContent,
      "client_company.name"
    );
  }
  public get clientVatNumber() {
    return this.$_.get(
      this.$invoiceData.invoiceDataContent,
      "client_company.vat_number"
    );
  }
  public get clientRegNumber() {
    return this.$_.get(
      this.$invoiceData.invoiceDataContent,
      "client_company.reg_number"
    );
  }
  public get brandAddress() {
    return this.$_.trim(
      this.$invoiceData.invoiceDataContent.brand.company_address
    );
  }
  public get brandVatNumber() {
    return this.$_.get(
      this.$invoiceData.invoiceDataContent,
      "brand.vat_number"
    );
  }
}
